<template>
	<span>
		<v-chip
                :disabled="isPostReadOnly"
                :key="tag.id"
                @input="deleteTag(tag)"
                close
                color="#979797"
                outline
                v-for="tag in tags"
                v-if="tags.length > 0"
        >{{tag}}
		</v-chip>
        <el-autocomplete
                :disabled="isPostReadOnly"
                :fetch-suggestions="queryTags"
                :trigger-on-focus="false"
                @keyup.enter.native="addNewTagToSingleComment"
                @select="addNewTagToSingleComment"
                class="inline-input"
                ref="saveTagInput"
                size="small"
                v-if="inputVisible"
                v-model="newSingleTag"
        >
            <i slot="suffix" class="el-icon-circle-close el-input__icon add-cursor" @click="closeTagInput"></i>
        </el-autocomplete>
		<el-button :disabled="isPostReadOnly" @click="showInput" class="button-new-tag" size="small" v-else>
			<v-icon left small style="font-size: 15px;">local_offer</v-icon>
		</el-button>
		<v-chip color="error" label outline v-show="tagExist">Tag already exist!</v-chip>
	</span>
</template>

<script>
	import {mapActions, mapState, mapMutations} from 'vuex';
	import authCurrentUser from "@/mixins/authCurrentUser";

	export default {
		props: {
			tags: {
				type: Array,
			},
			comment_id: {
				type: String,
				required: true
			},
			isPostReadOnly: {
				type: Boolean
			}
		},
		mixins: [authCurrentUser],
		data() {
			return {
				inputVisible: false,
				tagExist: false,
				newSingleTag: '',
			}
		},

		computed: {
			...mapState([
				'monitor',
				'facebookSummary'
			]),

			...mapState('sentiment', [
				"selectedTag"
			]),

			...mapState('mention', [
				"monitorSinglePost"
			]),

			tagsCloudData() {
				return this.facebookSummary.fbcomments.tags_cloud_data
			},

            tagsToQuery(){
				return this.tagsCloudData.map(tagObj =>({value: tagObj.tag, link: tagObj.value}))
            }
		},

		methods: {
			...mapActions(['createCommentTags', 'fetchFacebookSummary']),

			...mapMutations('sentiment', [
				'setSelectedTags'
			]),

			addNewTagToSingleComment() {
				if (this.newSingleTag) {
					let newTag = this.newSingleTag.toLowerCase();
					if (!this.tags.includes(newTag)) {
						const existTag = this.tagsCloudData.find(e => e.tag === newTag);
						existTag ? existTag.count += 1 : this.tagsCloudData.push({tag: newTag, count: 1});
						this.tags.push(newTag);
						this.createCommentTags([
							{
								tags: this.tags,
								monitor_uuid: this.monitor.monitor_uuid || this.$route.params.monitor_uuid,
								comment_id: this.comment_id
							}
						]).then(({data}) => {
							this.$ua.trackEvent("Comment", "click", `${this.authenticatedUser.email || 'User'} add ${newTag} to monitor(${this.$route.params.monitor_uuid || 'Monitor'})'s single comment(${this.comment_id})`);
							if (data.success && data.success.message !== 'Successfully Updated Tags') {
								this.$emit("error", data.success.message);
							}
						}).catch(_ => this.$emit("error", "Error occur when adding single tag to comment"));
					} else {
						this.tagExist = true
					}
				}
				this.inputVisible = false
				this.newSingleTag = ''
			},

			showInput() {
				this.inputVisible = true
				this.tagExist = false
				this.$nextTick(_ => {
					this.$refs.saveTagInput.$refs.input.focus()
				});
			},

			deleteTag(tag) {
				if (tag) {
					const existTag = this.tagsCloudData.find(e => e.tag === tag);
					if (existTag) {
						if (existTag.count > 1) {
							existTag.count -= 1
						} else {
							this.tagsCloudData.splice(this.tagsCloudData.indexOf(existTag), 1);
							this.setSelectedTags({values:this.selectedTag.values.filter(tag => tag !== existTag.tag)});
						}
					}
					let index = this.tags.indexOf(tag);
					this.tags.splice(index, 1);
					this.createCommentTags([
						{
							monitor_uuid: this.monitor.monitor_uuid || this.$route.params.monitor_uuid,
							tags: this.tags,
							comment_id: this.comment_id
						}
					]).then(_ => {
						this.$ua.trackEvent("Comment", "click", `${this.authenticatedUser.email} delete ${tag} from monitor(${this.$route.params.monitor_uuid || 'Monitor'}) single comment(${this.comment_id})`);
					})
				}
			},

            queryTags(searchString, cb){
                let tags = this.tagsToQuery.filter(tagObj => tagObj.value.toLowerCase().includes(searchString.toLowerCase()));
                cb(tags);
            },

            closeTagInput(){
				if(this.newSingleTag && this.inputVisible){
					this.newSingleTag = "";
					this.$refs.saveTagInput.$refs.input.focus();
					return;
                }
				this.inputVisible = false;
            }
		},
	}
</script>

<style>
    .input-new-tag .el-input__inner {
        border: 1px solid #9e9e9e !important;
    }

    .button-new-tag {
        margin-left: 5px;
    }

    .input-new-tag {
        width: 90px;
        margin-left: 10px;
    }

    .el-button--small {
        padding: 0px;
        display: inline-block;
        width: 25px;
        height: 25px;
        text-align: center;
        line-height: 25px;
        border: none;
    }
</style>


